var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.equipment && _vm.test
    ? _c(
        "div",
        [
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.eqipmentnumber")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", disabled: "disabled" },
                domProps: { value: _vm.eqNumber }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.deviceName")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", disabled: "disabled" },
                domProps: { value: _vm.equipment.name }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.date")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-10" },
              [
                _c("Datepicker", {
                  attrs: {
                    "monday-first": true,
                    language: _vm.datepickerDE,
                    "bootstrap-styling": true,
                    disabled: !_vm.editable
                  },
                  model: {
                    value: _vm.test.testDate,
                    callback: function($$v) {
                      _vm.$set(_vm.test, "testDate", $$v)
                    },
                    expression: "test.testDate"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.protocolNumber")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.test.protocolNumber,
                    expression: "test.protocolNumber"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.test.protocolNumber },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.test, "protocolNumber", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.tester")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.test.testPerson,
                    expression: "test.testPerson"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.test.testPerson },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.test, "testPerson", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          !_vm.test.measurementSpecifications.length
            ? _c("div", { staticClass: "row my-1" }, [
                _c("div", { staticClass: "col-2" }, [
                  _vm._v(_vm._s(_vm.$t("testEquipment.test.range")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.test.testSpecification,
                        expression: "test.testSpecification"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", disabled: "disabled" },
                    domProps: { value: _vm.test.testSpecification },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.test,
                          "testSpecification",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.test.expectedError,
                        expression: "test.expectedError"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", disabled: "disabled" },
                    domProps: { value: _vm.test.expectedError },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.test, "expectedError", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.test.error,
                        expression: "test.error"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", disabled: !_vm.editable },
                    domProps: { value: _vm.test.error },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.test, "error", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.assesment")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.test.grade,
                    expression: "test.grade"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.test.grade },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.test, "grade", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.note")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.test.note,
                    expression: "test.note"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.test.note },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.test, "note", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.test.mandatory")))
            ])
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("TestEquipmentMeasurements", { attrs: { test: _vm.test } }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("image-viewer", {
            attrs: {
              isShowDelete: _vm.allowMediaDelete,
              medias: _vm.test.files
            },
            on: {
              "removed-media": function($event) {
                return _vm.removeMedia($event)
              }
            }
          }),
          _vm._v(" "),
          _c("DropZone", {
            attrs: { formId: "dz_test" + _vm._uid },
            on: { uploaded: _vm.fileUploaded }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }